module.exports = __webpack_public_path__ + "img/Compeltedicon.b6c47a86.svg";